export default __webpack_public_path__ + "static/media/background-plant1.a18c768a.png";